import { Spacer, Text } from '@vinted/web-ui'

import ResponsiveWrapper from '../../ReponsiveWrapper'

type Props = {
  title: string
  body: string
  linkText: string
}

const FactBlock = ({ title, body, linkText }: Props) => {
  return (
    <section className="page-section__fact-block">
      <div className="page-section__content">
        <Text as="h3">
          <div className="safety_fact-title">{title}</div>
        </Text>
        <ResponsiveWrapper mobile={<Spacer />} desktop={<Spacer size={Spacer.Size.Large} />} />
        <Text as="span" html>
          <div className="safety_body">{body}</div>
        </Text>
        <Spacer size={Spacer.Size.Large} />
        <Text as="span" theme="primary" html clickable>
          {linkText}
        </Text>
      </div>
    </section>
  )
}

export default FactBlock
